import React, { ComponentProps } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { AttributeGroupInfoEditView } from './views/AttributeGroupInfoEditView';
import { AttributeGroupInfoDefaultView } from './views/AttributeGroupInfoDefaultView';

type AttributeGroupInfoProps = Views<
  DefaultView<AttributeGroupInfoDefaultView> & OptionalEditView<AttributeGroupInfoEditView>
>;

/**
 * Block that describes rules of a Attribute Group and its Form to Edit them.
 */
function AttributeGroupInfo({ views, activeView }: AttributeGroupInfoProps) {
  if (activeView === 'edit' && views.edit) {
    return <AttributeGroupInfoEditView {...views.edit} />;
  }

  return <AttributeGroupInfoDefaultView {...views.default} />;
}

export const AttributeGroupInfoBlock = asBlock(AttributeGroupInfo, BlockType.attributegroupinfo);
export type AttributeGroupInfoBlock = ComponentProps<typeof AttributeGroupInfoBlock>;
